'use strict';

exports.__esModule = true;
exports.isString = isString;
exports.arrify = arrify;
exports.resolve = resolve;
exports.getWindowSize = getWindowSize;
var _ = require('lodash');

function isString(value) {
	return typeof value === 'string';
}

function arrify(obj) {
	if (!obj) {
		return [];
	}

	if (_.isArray(obj)) {
		return obj;
	}

	return [obj];
}

function resolve(object, path) {
	return path.split('.').reduce(function (prev, curr) {
		return prev[curr];
	}, object || this);
}

function getWindowSize() {
	var w = window,
	    d = document,
	    e = d.documentElement,
	    g = d.getElementsByTagName('body')[0],
	    x = w.innerWidth || e.clientWidth || g.clientWidth,
	    y = w.innerHeight || e.clientHeight || g.clientHeight;

	return { width: x, height: y };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/utils.js
 ** module id = 248
 ** module chunks = 2
 **/